import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import React from "react";

const eventStatusColors = {
  canceled: "bg-red-300",
  completed: "bg-blue-300",
  inprogress: "bg-blue-500",
  approved: "bg-green-300",
  requested: "bg-yellow-300",
}

const eventStatusLabels = {
  canceled: "Canceled",
  completed: "Completed",
  inprogress: "In Progress",
  approved: "approved",
  requested: "Requested",
}

export function EventStatusLegendCard({

}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Event Status Legend</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-6">
          {Object.entries(eventStatusLabels).map(([status, label]) => (
            <div key={status} className="flex items-center gap-2">
              <div
                className={cn(
                  "w-4 h-4 rounded",
                  eventStatusColors[status as keyof typeof eventStatusColors]
                )}
              />
              <span className="text-sm font-medium">{label}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}         
          
          
          
          
